import { FC } from 'react';
import {
  Badge,
  Box,
  Divider,
  Flex,
  Heading,
  PendingClockIcon,
  Text,
} from '@agrotoken-tech/ui';

export interface SignUpRequestDetailHeaderProps {
  title?: string;
  badgeText?: string;
  subtitle?: string;
  rightButton?: JSX.Element;
}

export const SignUpRequestDetailHeader: FC<SignUpRequestDetailHeaderProps> = (
  props,
) => {
  const { title, badgeText, subtitle, rightButton } = props;

  return (
    <Box mb={10}>
      <Flex justifyContent="space-between">
        <Flex direction="column">
          <Flex alignItems="center" gap={4} mb={1}>
            <Heading size="md" variant="medium">
              {title}
            </Heading>
            <Badge>
              <>
                <PendingClockIcon /> {badgeText}
              </>
            </Badge>
          </Flex>
          <Text size="lg" variant="regular" mb={7}>
            {subtitle}
          </Text>
        </Flex>
        {rightButton}
      </Flex>
      <Divider />
    </Box>
  );
};

export default SignUpRequestDetailHeader;
